<svg fill="none" height="24" viewBox="0 0 21 24" width="21" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.60018 14.2287C6.78954 14.2287 6.94304 14.0752 6.94304 13.8858C6.94304 13.6965 6.78954 13.543 6.60018 13.543C6.41083 
    13.543 6.25732 13.6965 6.25732 13.8858C6.25732 14.0752 6.41083 14.2287 6.60018 14.2287Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M10.2858 24.0001C11.7429 24.0001 12.8572 22.8858 12.8572 21.5144H7.71436C7.71436 22.8858 8.82864 24.0001 10.2858 24.0001Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M18 16.6286V10.4571C18 6.68571 15.8571 3.51429 12.1714 2.65714V1.8C12.2571 0.857143 11.3143 0 10.2857 0C9.25714 0 8.4 
    0.857143 8.4 1.88571V2.74286C4.62857 3.51429 2.57143 6.68571 2.57143 10.4571V16.6286L0 19.1143V20.3143H20.5714V19.1143L18 
    16.6286ZM15.5143 15L15.1714 15.3429C14.6571 15.8571 13.8 15.8571 13.2857 15.2571L10.8 12.5143C10.7143 12.3429 10.7143 12.1714 
    10.8 12.0857L11.3143 11.5714L10.8 11.0571L7.28571 15.3429C6.94286 15.7714 6.34286 15.7714 6 15.4286C5.91429 15.3429 5.14286 
    14.5714 5.05714 14.4857C4.71429 14.1429 4.71429 13.5429 5.14286 13.2L9.42857 9.68571L6.85714 7.2L6.6 7.45714C6.51429 7.54286 
    6.25714 7.54286 6.17143 7.45714L5.05714 6C4.97143 5.91429 4.97143 5.74286 5.05714 5.65714L5.82857 4.88571C5.91429 4.8 6.08571 
    4.8 6.17143 4.88571L7.62857 6.08571C7.71429 6.17143 7.71429 6.34286 7.62857 6.51429L7.37143 6.77143L9.85714 9.25714L11.1429 
    8.22857C10.6286 7.28571 10.8 6.08571 11.5714 5.31429C12.1714 4.71429 13.0286 4.45714 13.8857 4.62857C14.1429 4.71429 14.2286 
    4.97143 14.0571 5.14286L13.0286 6.17143C12.8571 6.34286 12.8571 6.68571 13.0286 6.85714C13.2 7.02857 13.3714 7.2 13.6286 
    7.45714C13.7143 7.71428 14.0571 7.71428 14.2286 7.45714L15.2571 6.42857C15.4286 6.25714 15.6857 6.34286 15.7714 6.6C15.9429 
    7.37143 15.6857 8.31429 15.0857 8.91428C14.3143 9.68571 13.1143 9.85714 12.1714 9.34286L11.1429 10.5429L11.7429 11.1429L12.1714 
    10.7143C12.2571 10.6286 12.5143 10.6286 12.6 10.7143L15.4286 13.2C15.9429 13.6286 16.0286 14.4857 15.5143 15Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
